import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';

declare var $: any;

declare function notify(): any;

@Component({
    selector: 'app-question-witness-details',
    templateUrl: './question-witness-details.component.html',
    styleUrls: ['./question-witness-details.component.scss'],
    standalone: false
})
export class QuestionWitnessDetailsComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() showSkip = true;
  @Input() readonly = false;
  @Output() questionAnswer = new EventEmitter();

  witnessForm: FormGroup;
  skipped = false;
  unavailable = false;
  uniqueControlName = `witness-details-${newGuid()}`;

  constructor(private fb: FormBuilder) {
    this.witnessForm = this.fb.group({
      witnesses: this.fb.array([])
    });
  }

  ngOnInit(): void {
    this.trackFormChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;

      if (this.question?.answer) {
        if (this.question.answer.includes('fullName')) {
          const witnesses = JSON.parse(this.question.answer);
          witnesses?.forEach((witness: any) => {
            this.addWitnessFilled(witness?.fullName, witness?.mobileNumber, witness?.emailAddress);
          });
        } else if (this.question?.answer.includes('Skipped')) {
          this.skipped = true;
        } else if (this.question?.answer.includes('unavailable')) {
          this.unavailable = true;
        }
      } else {
        this.witnesses().push(this.newWitness());
      }
    }

    if (changes?.showSkip?.currentValue !== changes?.showSkip?.previousValue) {
      this.showSkip = changes?.showSkip?.currentValue;
    }
  }

  onSkippedChange(): void {
    if (this.skipped) {
      this.unavailable = false;

      this.notifyMessage(
        '<strong>You will be reminded to complete this at a later stage.</strong>',
        'info',
        'lg',
        'info',
        true,
        350,
        5000
      );
    }
    this.submit();
  }

  onUnavailableChanged(): void {
    if (this.unavailable) {
      this.skipped = false;
    }
    this.submit();
  }

  notifyMessage(message: string, icon: string, size: string, style: string, close: boolean, speed: number, duration: number): void {
    notify()?.init({
      message, // required
      icon,   // default: null; options: 'info', 'complete', or any icon-name really
      size,     // default: null; options: 'lg'
      style,  // default: null; options: 'info', 'success',
      close,    // default: false (close button enabled, auto-close duration removed)
      speed,     // default: 350 (fade in/out speed)
      duration  // default: 5000 (duration active)
    });
  }

  addWitnessFilled(fullName: string, mobileNumber, emailAddress): void {
    const formGroup = this.newWitness();
    formGroup.controls.fullName.setValue(fullName);
    formGroup.controls.mobileNumber.setValue(mobileNumber);
    formGroup.controls.emailAddress.setValue(emailAddress);
    this.witnesses().push(formGroup);
  }

  trackFormChanges(): void {
    this.witnessForm?.valueChanges.subscribe(() => {
      if (this.witnessForm?.valid) {
        this.submit();
      } else {
        this.question.answer = '';
        this.questionAnswer.emit(this.question);
      }
    });
  }

  witnesses(): FormArray {
    return this.witnessForm?.get('witnesses') as FormArray;
  }

  newWitness(): FormGroup {
    return this.fb.group({
      fullName: ['', Validators.required],
      mobileNumber: ['', Validators.required],
      emailAddress: ['', Validators.email]
    });
  }

  addWitness(): void {
    if (this.witnessForm?.valid && !this.skipped && !this.unavailable) {
      this.witnesses().push(this.newWitness());
    }
  }

  removeWitness(witnessIndex: number): void {
    this.witnesses().removeAt(witnessIndex);
  }

  submit(): void {
    let answer = '';
    if (this.skipped || this.unavailable) {
      if (this.skipped) {
        answer = 'Skipped';
      } else if (this.unavailable) {
        answer = 'unavailable';
      }
    } else {
      if (this.witnessForm?.valid) {
        const witnessArray = [];
        const witnesses = this.witnesses().controls;
        witnesses.forEach((element: any) => {
          const fullName = element.get('fullName').value;
          const mobileNumber = element.get('mobileNumber').value;
          const emailAddress = element.get('emailAddress').value;
          const witness = {
            fullName,
            mobileNumber,
            emailAddress
          };
          witnessArray.push(witness);

        });
        answer = JSON.stringify(witnessArray);
      }
    }
    this.question.answer = answer;
    this.questionAnswer.emit(this.question);
  }

}
